/**
 * Import and instantiate front end modules
 */

import { updateBodyClassname } from './core/body';
import { navSearch } from './core/search';
import { init as caseStudiesMap } from './blocks/case-studies-map';
import { mobileNav } from './core/mobile-nav';
import { mobileNavToggle } from './core/mobile-nav-toggle';
import { closePopUp } from './blocks/pop-up';
//import { surveyReveal } from './blocks/survey-reveal';
import { heroSlider } from './blocks/hero-slider';

updateBodyClassname();
navSearch();
caseStudiesMap('case-studies-map');
mobileNav();
mobileNavToggle();
closePopUp();
//surveyReveal();
heroSlider();